import Highcharts from 'highcharts';

export const AXIS_COLOR = '#aaaaaa';

export const baseChart: Highcharts.Options = {
  credits: {
    enabled: false,
  },

  exporting: {
    buttons: {
      contextButton: {
        enabled: false,
      },
    },
  },

  legend: {
    enabled: false,
  },

  title: {
    text: undefined,
  },

  tooltip: {
    enabled: false,
  },

  xAxis: {
    type: 'category',
  },

  yAxis: {
    title: {
      text: undefined,
    },
  },
};
